import React from 'react';
import { useParams } from 'react-router-dom';

const EventLoader = () => {
  const { tournamentName } = useParams();
  const skeletonCount = tournamentName ? 1 : 10;

  const eventItemSkeleton = i => (
    <div className="tournament-scroll-event" key={i}>
      <div className="tournament-scroll-event-info">
        <div className="menu-item-container">
          <div className="skeleton-event">
            <div className="skeleton-participants">
              <div className="title-line-1 skeleton" />
              <div className="title-line-2 skeleton" />
              <div className="title-line-2 skeleton" />
            </div>
          </div>
        </div>
      </div>
      <div className="tournament-scroll-outcomes-row-container">
        <div className="tournament-scroll-outcomes-row">
          <div className="tournament-scroll-market">
            <div className="tournament-scroll-market-name">
              <div className="title-line-3 skeleton" />
            </div>
            <div className="market-row">
              <div className="outcome primary row">
                <div className="skeleton-odds skeleton" />
              </div>
              <div className="outcome primary row">
                <div className="skeleton-odds skeleton" />
              </div>
              <div className="outcome primary row">
                <div className="skeleton-odds skeleton" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return Array.from({ length: skeletonCount }, (_, i) => eventItemSkeleton(i));
};

export default EventLoader;
